const MENU_PERMISSIONS_LOADING = "menu/permissions/PERMISSIONS_LOADING";
const MENU_PERMISSIONS_SUCCESS = "menu/permissions/PERMISSIONS_SUCCESS";
const MENU_PERMISSIONS_FAIL = "menu/permissions/PERMISSIONS_FAIL";

export default function (state={},action={}){
  switch(action.type){
    case MENU_PERMISSIONS_LOADING:
      return {
        ...state,
        loading:true
      };
    case MENU_PERMISSIONS_SUCCESS:
      console.log(action.result);
      return {
        ...state,
        loading:false,
        loaded:true,
        data:action.result
      };
    case MENU_PERMISSIONS_FAIL:
      return {
        ...state,
        loading:false,
        loaded:false,
        error:action.msg
      };
    default:
      return state;
  }
}

export function getPlatformMenuPermission(){
  return {
    types:[MENU_PERMISSIONS_LOADING,MENU_PERMISSIONS_SUCCESS,MENU_PERMISSIONS_FAIL],
    promise:client=>client.get('authority/platform/resource/queryResourceByCodeOrRefer')
  }
}
export function getMenuPermission(){
  return {
    types:[MENU_PERMISSIONS_LOADING,MENU_PERMISSIONS_SUCCESS,MENU_PERMISSIONS_FAIL],
    promise:client=>client.get('/authority/mall/resource/queryResourceByCodeOrRefer')
  }
}
